import { useLayoutEffect, useState } from 'react';
import { isEqual } from 'lodash';
import useGetter from './useGetter';

/**
 * @template {HTMLElement} E
 * @template P
 * @param {import('react').MutableRefObject<E>} elementRef
 * @param {(rect: DOMRect) => P} processor
 * @returns {Partial<P>}
 */
export default function useRectProperties(elementRef, processor) {
    const [value, setValue] = useState({});

    const getProcessor = useGetter(processor);

    useLayoutEffect(() => {
        const interval = setInterval(() => {
            const rect = elementRef?.current?.getBoundingClientRect();

            if (!rect) return;

            const value = getProcessor()(rect);

            setValue(prev => isEqual(prev, value) ? prev : value);
        }, 0);

        return () => clearInterval(interval);
    }, [elementRef]);

    return value;
}